import {Component, EventEmitter, Inject, Output} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
    selector: 'app-delete-info-dialog',
    templateUrl: './delete-info-dialog.component.html',
    styleUrls: ['./delete-info-dialog.component.scss']
})
export class DeleteInfoDialogComponent {

    @Output() closeDialogEvent: EventEmitter<void> = new EventEmitter<void>();
    noOfDeleted: number;
    noOfTotal: number;

    constructor(private translate: TranslateService, @Inject(MAT_DIALOG_DATA) data: { noOfDeleted: number, noOfTotal: number }) {
        this.noOfDeleted = data.noOfDeleted;
        this.noOfTotal = data.noOfTotal;
    }

}
